import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PostChangeEmailRequest = {
    currentPassword: string;
    email: string;
};

export const patchChangeEmail = createPatchEndpoint<PostChangeEmailRequest>(
	'/api/v3/core/users/current/change-email'
);
